import { RootState } from '@reducers';

export const selectMobileNumberPage = (state: RootState) => state.userDashboardRouteReducer.mobileNumberPageReducer;
